export const BlueprintContentCIC: any[] = [
    {
      make: 'Appliances',
      id: 2,
      categories: [
        {
          id: 1,
          title: "Camera",
          imageUrl: 'TENANT_GENERIC_CONFIG',
          variants: [
            {
              model: "SKU360-3014",
              brand: 'UST',
              category: 'Camera',
              variant: 'Gen 1',
              renewedYear: '2021',
              launchedDate: '05 Oct 2020',
              productionEndDate: '05 Nov 2020',
              saleCeasedDate: '05 Dec 2020',
              componentList: [],
              ontology: {
                url: 'TENANT_GENERIC_CONFIG'
              },
              image: {
                url: 'TENANT_GENERIC_CONFIG'
              }
            }
          ]
        },
        {
          id: 2,
          title: "Coffee Maker",
          imageUrl: 'TENANT_GENERIC_CONFIG',
          variants: [
            {
              model: "Gen 2",
              brand: 'UST',
              category: 'Coffee Maker',
              variant: 'Gen 1',
              renewedYear: '2021',
              launchedDate: '05 Oct 2020',
              productionEndDate: '05 Nov 2020',
              saleCeasedDate: '05 Dec 2020',
              componentList: [],
              ontology: {
                url: 'TENANT_GENERIC_CONFIG'
              },
              image: {
                url: 'TENANT_GENERIC_CONFIG'
              }
            }
          ]
        },
        {
          id: 3,
          title: "Thermocouples",
          imageUrl: 'TENANT_GENERIC_CONFIG',
          variants: [
            {
              model: "Coldra-2018",
              brand: 'UST',
              category: 'Thermocouples',
              variant: 'Gen 1',
              renewedYear: '2021',
              launchedDate: '05 Oct 2020',
              productionEndDate: '05 Nov 2020',
              saleCeasedDate: '05 Dec 2020',
              componentList: [],
              ontology: {
                url: 'TENANT_GENERIC_CONFIG'
              },
              image: {
                url: 'TENANT_GENERIC_CONFIG'
              }
            }
          ]
        },
        {
          id: 4,
          title: "Water Cooler",
          imageUrl: 'TENANT_GENERIC_CONFIG',
          variants: [
            {
              model: "SKU360-3014",
              brand: 'UST',
              category: 'Water Cooler',
              variant: 'Gen 1',
              renewedYear: '2021',
              launchedDate: '05 Oct 2020',
              productionEndDate: '05 Nov 2020',
              saleCeasedDate: '05 Dec 2020',
              componentList: [],
              ontology: {
                url: 'TENANT_GENERIC_CONFIG'
              },
              image: {
                url: 'TENANT_GENERIC_CONFIG'
              }
            }
          ]
        },
        {
          id: 5,
          title: "Walk-in-cooler",
          imageUrl: 'TENANT_GENERIC_CONFIG',
          variants: [
            {
              model: "SKU360-3014",
              brand: 'UST',
              category: 'Walk-in-cooler',
              variant: 'Gen 1',
              renewedYear: '2021',
              launchedDate: '05 Oct 2020',
              productionEndDate: '05 Nov 2020',
              saleCeasedDate: '05 Dec 2020',
              componentList: [],
              ontology: {
                url: 'TENANT_GENERIC_CONFIG'
              },
              image: {
                url: 'TENANT_GENERIC_CONFIG'
              }
            }
          ]
        }
      ]
    }
  ];
  
  export const RecentActivityContentCIC: any[] = [
    {
      title: 'Camera',
      description: 'New variant added',
      updatedDate: '2024-04-09T13:54:38.000+0000',
      status: {
        type: "added",
        title: "Added",
        colorCode: "#1F9254",
        backgroundColorCode: "#EBF9F1"
      }
    },
    {
      title: 'Walk-in-cooler',
      description: 'Variant updated',
      updatedDate: '2024-04-08T13:54:38.000+0000',
      status: {
        type: "edited",
        title: "Edited",
        colorCode: "#b1c309",
        backgroundColorCode: "#FFC55526"
      }
    },
    {
      title: 'Coffee maker',
      description: 'New variant added',
      updatedDate: '2024-04-07T13:54:38.000+0000',
      status: {
        type: "added",
        title: "Added",
        colorCode: "#1F9254",
        backgroundColorCode: "#EBF9F1"
      }
    },
    {
      title: 'Water Cooler',
      description: 'Variant updated',
      updatedDate: '2024-04-06T13:54:38.000+0000',
      status: {
        type: "edited",
        title: "Edited",
        colorCode: "#b1c309",
        backgroundColorCode: "#FFC55526"
      }
    },
    {
      title: 'Camera',
      description: 'New variant added',
      updatedDate: '2024-04-05T13:54:38.000+0000',
      status: {
        type: "added",
        title: "Added",
        colorCode: "#1F9254",
        backgroundColorCode: "#EBF9F1"
      }
    },
    {
      title: 'Walk-in-cooler',
      description: 'Variant updated',
      updatedDate: '2024-04-04T13:54:38.000+0000',
      status: {
        type: "edited",
        title: "Edited",
        colorCode: "#b1c309",
        backgroundColorCode: "#FFC55526"
      }
    },
    {
      title: 'Coffee maker',
      description: 'New variant added',
      updatedDate: '2024-04-03T13:54:38.000+0000',
      status: {
        type: "added",
        title: "Added",
        colorCode: "#1F9254",
        backgroundColorCode: "#EBF9F1"
      }
    },
    {
      title: 'Water Cooler',
      description: 'Variant updated',
      updatedDate: '2024-04-02T13:54:38.000+0000',
      status: {
        type: "edited",
        title: "Edited",
        colorCode: "#b1c309",
        backgroundColorCode: "#FFC55526"
      }
    }
  ];